import React from 'react';
import '../styles/Loading.css';

const Loading = () => (
  <div className="Loading">Loading</div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js